/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  LibOwnableRichErrorsV061,
  LibOwnableRichErrorsV061Interface,
} from "../LibOwnableRichErrorsV061";

const _abi = [
  {
    inputs: [],
    name: "ONLY_OWNER_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OnlyOwnerError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "TRANSFER_OWNER_TO_ZERO_ERROR_BYTES",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TransferOwnerToZeroError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

export class LibOwnableRichErrorsV061__factory {
  static readonly abi = _abi;
  static createInterface(): LibOwnableRichErrorsV061Interface {
    return new utils.Interface(_abi) as LibOwnableRichErrorsV061Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LibOwnableRichErrorsV061 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LibOwnableRichErrorsV061;
  }
}
